/* Progressive enhancement only: Shopify handles the POST, consent and customer records. */
(() => {
  if (customElements.get('cibocca-footer-newsletter')) return;
  customElements.define('cibocca-footer-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const form = this.querySelector('form');
      const feedback = form.querySelector('[data-footer-result]');
      const ownResponse = location.hash === `#${form.id}` && feedback;
      const editor = this.dataset.editor === 'true' || !!window.Shopify?.designMode;
      if (ownResponse && !editor) {
        feedback.focus({ preventScroll: true });
        if (feedback.dataset.footerResult === 'error') {
          const email = form.querySelector('[type="email"]');
          email.setAttribute('aria-invalid', 'true');
          email.setAttribute('aria-describedby', `${email.getAttribute('aria-describedby')} ${feedback.id}`);
        } else {
          // A confirmed native receipt also suppresses the popup; never store an email.
          const popup = document.querySelector('cibocca-newsletter-popup');
          const days = Number(popup?.dataset.successDays) || 180;
          try {
            const until = Math.max(Number(localStorage.getItem('cibocca:newsletter:until')) || 0, Date.now() + days * 86400000);
            localStorage.setItem('cibocca:newsletter:until', String(until));
            sessionStorage.setItem('cibocca:newsletter:shown', '1');
          } catch (_) { /* Signup works without browser preference storage. */ }
        }
      }
      form.addEventListener('submit', (event) => {
        if (editor) {
          event.preventDefault();
          const message = this.querySelector('.cibocca-footer-signup__editor-message');
          message.textContent = this.dataset.editorSubmit;
          message.hidden = false;
        }
      }, { signal });
    }

    disconnectedCallback() { this.controller?.abort(); }
  });
})();
